module.exports = __webpack_public_path__ + "static/Muli-ExtraBold.ae2a95d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-ExtraBold.ttf
// module id = 332
// module chunks = 114276838955818